import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const Adam = (props) => {
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: {
          eq: "components/pages/AboutPage/Sections/TeamSection/images/adam.jpg"
        }
      ) {
        childImageSharp {
          fixed(width: 92, height: 92, quality: 100, cropFocus: ATTENTION) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return <Img fixed={data.file.childImageSharp.fixed} {...props} />
}

export default Adam
